export type SearchQuery = { kind: 'empty' } | { kind: 'row'; n: number } | { kind: 'text'; q: string }

/**
 * Freelo #32253582: the "Add predecessor/successor" picker only searched the server, so typing a
 * bare row number (what MS Project users expect) did nothing. This classifies the raw input so the
 * combobox can resolve a row number instantly and locally, falling back to the existing
 * name/WBS-code server search for everything else. A WBS code like `1.2` or `1a` is NOT a row
 * number — it still goes to the server.
 */
export const classifySearchQuery = (raw: string): SearchQuery => {
  const trimmed = raw.trim()
  if (!trimmed) return { kind: 'empty' }
  if (/^\d+$/.test(trimmed)) return { kind: 'row', n: Number(trimmed) }
  return { kind: 'text', q: trimmed }
}
